import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { isEmpty } from 'lodash';

import { RequestResponse, isClientError, isServerError } from '@api/services/types/RequestStatus';

export interface AdaptRequestResponseProps<T> {
  data?: T;
  error: SerializedError | FetchBaseQueryError | undefined;
  isSuccess: boolean;
  isFetching: boolean;
  isLoading: boolean;
  isError: boolean;
  isUninitialized: boolean;
}

const adaptRequestResponse = <T>({
  data,
  error,
  isSuccess,
  isFetching,
  isLoading,
  isError,
  isUninitialized,
}: AdaptRequestResponseProps<T>): RequestResponse<T> => {
  return {
    status: {
      isError,
      isSuccess,
      isFetching,
      isLoading,
      isServerError: isServerError(error),
      isClientError: isClientError(error),
      isSuccessWithData: isSuccess && !isEmpty(data),
      isSuccessWithNoData: isSuccess && isEmpty(data),
      isUninitialized,
    },
    data,
  };
};

export { adaptRequestResponse };
